import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {useAvailableUserStatuses} from 'src/hooks/dictionaries';

import {BULK_IMPORT_USERS_STEPS} from '../constants';

import {clearUsersBulkImport, selectBulkUserImportStep} from './services/user-bulk-import.slice';
import {UploadFileStep} from './steps/upload-file-step/upload-file-step';
import {ValidateFileStep} from './steps/validate-file-step/validate-file-step';

import type {Error} from 'src/openapi/admin/models/Error';

export const UserBulkImport = () => {
    const dispatch = useDispatch();

    const step = useSelector(selectBulkUserImportStep);
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : 0;
    const [availableStatuses, setAvailableStatuses] = useState<string[] | null>(null);
    const {getAvailableStatuses} = useAvailableUserStatuses();

    useEffect(() => {
        return () => {
            dispatch(clearUsersBulkImport());
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const fetchData = async () => {
            const loadedAvailableStatuses: string[] | Error = await getAvailableStatuses(accountId);
            if (Array.isArray(loadedAvailableStatuses)) {
                setAvailableStatuses(loadedAvailableStatuses);
            }
        };
        fetchData();
    }, [accountId, getAvailableStatuses]);

    return (
        <>
            {step === BULK_IMPORT_USERS_STEPS.UPLOAD_FILE && availableStatuses ? (
                <UploadFileStep
                    accountId={accountId}
                    availableStatuses={availableStatuses}
                />
            ) : null}
            {step === BULK_IMPORT_USERS_STEPS.VALIDATE_FILE && availableStatuses ? (
                <ValidateFileStep
                    accountId={accountId}
                    availableStatusCodes={availableStatuses}
                />
            ) : null}
        </>
    );
};
